import React, { useState } from 'react';
import PropTypes from 'prop-types';

import pluralize from 'pluralize';
import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Deal from './deal';
import Totals from './totals';

export default function CollapsableRow({ deals, orderedColumns }) {
  const [collapsed, setCollapsed] = useState(false);

  if (!deals) return null;

  return (
    <React.Fragment>
      <tr className="collapsable-row clickable" onClick={() => setCollapsed(!collapsed)}>
        <td colSpan={deals.length === 1 ? orderedColumns.length : 2}>
          {pluralize(`${deals[0].dealType} deal`, deals.length, true)} at this property
          <FontAwesomeIcon className="ml-5" icon={collapsed ? faCaretDown : faCaretUp}/>
        </td>
        <Totals deals={deals} onlyColumns orderedColumns={orderedColumns.slice(2)} />
      </tr>
      {!collapsed && deals.map(deal => (
        <Deal className="collapsable-row" deal={deal} key={deal.id} orderedColumns={orderedColumns}/>
      ))}
    </React.Fragment>
  );
}

CollapsableRow.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.object),
  orderedColumns: PropTypes.array.isRequired
};
